import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiFundraiserMinimalAdapter,
  type FundraiserMinimal,
  type IApiFundraiserMinimal,
} from '@fmnts/api';
import { PagedApiResponse } from '@fmnts/api/shared';
import type { Observable } from 'rxjs';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FundraiserNextApi {
  private readonly adapter = new ApiFundraiserMinimalAdapter();

  constructor(private http: HttpClient) {}

  list(): Observable<FundraiserMinimal[]> {
    const url = '/api/next/fundraisers/';

    return this.http
      .get<PagedApiResponse<IApiFundraiserMinimal>>(url)
      .pipe(
        map((data) => data.results.map((item) => this.adapter.adapt(item))),
      );
  }

  get(id: string): Observable<FundraiserMinimal> {
    const url = `/api/next/fundraisers/${id}/`;

    return this.http
      .get<IApiFundraiserMinimal>(url)
      .pipe(map((item) => this.adapter.adapt(item)));
  }
}
